import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import ClientNavBar from "./clientPannel";

const ClientLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  return (
    <Box sx={{ display: "flex" }}>
      <ClientNavBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: "100%",
          mt: { xs: "40px", sm: "50px" },
          ml: { xs: 0 },
          transition: (theme) =>
            theme.transitions.create(["margin", "width"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          ...(isMobile && {
            p: 2,
          }),
          ...(isTablet && {
            p: 2.5,
          }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ClientLayout;
